import { useQuery } from '@tanstack/react-query'
import { fetchMyProjects } from './projects-api'

export function useProjectsQuery() {
  return useQuery({
    queryKey: ['projects', 'my'],
    queryFn: fetchMyProjects,
  })
}
